export default __webpack_public_path__ + "3a2a308e31c2b70e46ae49f10007b0a9.png";